import { useAppStore } from '@/stores/app';
import { toast } from 'sonner';
import { useShallow } from 'zustand/react/shallow';

/**
 * Hook to get the currently selected organization ID from the app store.
 */
export function useOrgId(): string | undefined {
  return useAppStore(useShallow(state => state.selectedOrganization?.id ?? state.selectedOrgStub?.id));
}

/**
 * Helper to show an error toast notification.
 * Replace with your app's toast/notification system if needed.
 */
export function showToast(message: string) {
  toast.error(message);
}
